module.exports = __webpack_public_path__ + "static/img/NPower-Selected.825f884.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fileTypes/NPower-Selected.png
// module id = 614
// module chunks = 0